import { getStore } from '../store/store';
import type FavoriteNodeViewState from '../store/schema/FavoriteNodeViewState';

export default function getFavoriteNodeViewStateFromId(
    favoriteId: string
): FavoriteNodeViewState | undefined {
    return getStore().favoriteNodeViewStates.get(favoriteId);
}
